import React, { useState } from "react";
import { Select, Form } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { CircleCheck, Sparkles } from "lucide-react";
import TextArea from "antd/es/input/TextArea";
import FormItem from "components/fields/FormItem";

const { Option } = Select;

const employees = [
  { name: "Ashley Palma", code: "EMP001", role: "Senior Developer", dept: "Engineering" },
  { name: "Saccharine Elupre", code: "EMP002", role: "Marketing Manager", dept: "Marketing" },
  { name: "Emily Rodriguez", code: "EMP003", role: "Frontend Developer", dept: "Engineering" },
  { name: "James Wilson", code: "EMP004", role: "HR Specialist", dept: "HR" },
  { name: "Lisa Anderson", code: "EMP005", role: "Financial Analyst", dept: "Finance" },
  { name: "David Martinez", code: "EMP006", role: "DevOps Engineer", dept: "Engineering" },
  { name: "Jennifer Lee", code: "EMP007", role: "UX Designer", dept: "Design" },
  { name: "Robert Taylor", code: "EMP008", role: "Sales Director", dept: "Sales" },
  { name: "Acee Cayanan", code: "EMP009", role: "Creative Director", dept: "Design" },
];

const EmployeeSelector = () => {
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  return (
    <Form layout="vertical">
      <div className="space-y-4">
        <FormItem label="Select Employee *" name="employee">
                <Select
                  showSearch
                  placeholder="Choose an employee to nominate"
                  optionFilterProp="children"
                  onChange={(value) => setSelectedEmployee(value)}
                  suffixIcon={<SearchOutlined />}
                  dropdownStyle={{ maxHeight: 300, overflowY: "auto" }}
                  value={selectedEmployee}
                  optionLabelProp="value" 
                >
                  {employees.map((emp) => (
                    <Option
                      key={emp.code}
                      value={emp.name} 
                    >
                      <div className="flex flex-col">
                        <div className="flex justify-start items-center gap-2 px-2">
                            <div className="w-4 flex justify-center">
                              <CircleCheck
                                size={16}
                                className={selectedEmployee === emp.name ? "opacity-100" : "opacity-0"}
                              />
                            </div>
                          <div className="flex flex-col">
                            <span>{emp.name}</span>
                            <span style={{ fontSize: 11, color: "#888" }}>
                              {emp.role} • {emp.dept}
                            </span>
                          </div>
                          </div>
                        </div>
                    </Option>
                  ))}
                </Select>
              </FormItem>
              <FormItem
                label="Why are you nominating this person?"
                name="reason"
                rules={[{ required: true, message: "Please provide a reason" }]}
              >
                <TextArea
                  id="reason"
                  className="input-field"
                  maxLength={255}
                  placeholder="Describe why this person deserves this award..."
                />
              </FormItem>
              <FormItem
                label="Provide specific examples"
                name="examples"
                rules={[{ required: true, message: "Please provide examples" }]}
              >
                <TextArea
                  id="examples"
                  className="input-field"
                  maxLength={255}
                  placeholder="Share concrete examples of actions, behaviors, or achievements that demonstrate why they deserve this award..."
                />
              </FormItem>

              <div className="flex gap-2 rounded-xl border border-blue-200 bg-blue-50/50 p-4 ">
                <div className="p-2">
                  <Sparkles className="h-5 w-5 text-blue-600"/>
                </div>
                <div>
                    <p className="text-blue-800 text-[13px]">Nomination Tips</p> 
                    <p className="text-blue-700 text-[12px]">Be specific and provide measurable examples. Include dates, projects, or situations where the nominee demonstrated the award criteria.</p>
                </div>
              </div>
      </div>
    </Form>
    
  );
};

export default EmployeeSelector;
